// extracted by mini-css-extract-plugin
var _1 = "ra-event-details-page-action";
var _2 = "ra-event-details-page-attendees";
var _3 = "ra-event-details-page-banner-content";
var _4 = "ra-event-details-page-card-additional";
var _5 = "ra-event-details-page-card-extra";
var _6 = "ra-event-details-page-card-share";
var _7 = "ra-event-details-page-centered";
var _8 = "ra-event-details-page-date-container";
var _9 = "ra-event-details-page-highlight";
var _a = "ra-event-details-page-highlight-row";
var _b = "ra-event-details-page";
var _c = "ra-event-details-page-rsvp-container";
var _d = "ra-event-details-page-share-centered";
export { _1 as "eventDetailsActionCls", _2 as "eventDetailsAttendeesCls", _3 as "eventDetailsBannerContentCls", _4 as "eventDetailsCardAdditionalCls", _5 as "eventDetailsCardExtraCls", _6 as "eventDetailsCardShareCls", _7 as "eventDetailsCenteredCls", _8 as "eventDetailsDateContainerCls", _9 as "eventDetailsHighlightCls", _a as "eventDetailsHighlightRowCls", _b as "eventDetailsPageCls", _c as "eventDetailsRsvpContainerCls", _d as "eventDetailsShareCenteredCls" }
